import {
  BrowserRouter as Router,
} from "react-router-dom";
import { useEffect } from "react";
import { toast } from "react-toastify";

import AppRoutes from "./routers/AppRoutes"; // test lỗi 1

// Firebase
import { messaging, onMessageListener, requestPermission } from "./services/firebase" // test lỗi 2
import ToastProvider from "Components/common/ToastProvider";
import { useDispatch } from "react-redux";
import { resetGuideTour, startTour } from "./states/guideTour/guideTourSlice";
import GuidedTourV2 from "./Components/common/GuidedTourV2";
import { isInAppBrowser } from "./utils/commonUtils";
import TawkController from "./Components/layout/TawkController";

function App() {
  const dispatch = useDispatch();
  // const [token, setToken] = useState(localStorage.getItem("token"));

  console.log({
    stripePromise: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY?.substring(0, 10)
  });

  useEffect(() => {
    // if (isInAppBrowser()) {
    //   console.warn("⚠️ Running inside an in-app browser. Some features may be disabled.");
    //   // => disable Firebase messaging, redirect, etc.
    //    return; // 🔴 Dừng hẳn, KHÔNG chạy Firebase
    // }

    if (messaging !== undefined && messaging !== null) {
      requestPermission();
    }
    let unsubscribe = null;

    // check late: unsubscribe = cleaner never work ???
    onMessageListener()
      .then((payload) => {
        toast.success(
          `${payload?.notification?.title}: ${payload?.notification?.body}`
        );
      })
      .catch(() => {
        console.log("Failed to get notification!");
      })
      .then((cleaner) => {
        unsubscribe = cleaner; // Store the cleanup function
      });
    return () => {
      console.log("Return Called....");
      if (typeof unsubscribe === "function") {
        unsubscribe();
      }
    };
  }, []);

  useEffect(() => {
    dispatch(
      resetGuideTour()
    );
  }, []);

  return (
    <Router>
      <AppRoutes />
      <ToastProvider />
      <GuidedTourV2 />
      <TawkController />
    </Router>
  );
}

export default App;
